import React, { useState } from 'react'
import { Input } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../';
import { setSfocRow, removeSfocRow } from '../../Store/Generic/ReportingSlice';

export default function SFOCRow(props: any) {
    const { SFOCSetting, vesselMachinery, index } = props;
    const [sfoc, setSfoc] = useState(false);
    const [eedixi, setEedixi] = useState(0)
    const [nox, setNox] = useState(0);
    const { VesselID, SfcoRow } = useSelector((state: RootState) => state.Reporting);
    const dispatch = useDispatch();

    const updateSFOCRow = () => {
        if (SfcoRow.length > 0) {
            dispatch(removeSfocRow(SfcoRow[index]));
            dispatch(setSfocRow(SFOCSetting[index]));
        } else {
            dispatch(setSfocRow(SFOCSetting[index]));
        }
    }

    const handleSFOCCheckbox = (e: any) => {
        if (e.target.checked === true) {
            setSfoc(true)
        } else {
            setSfoc(false)
            props.SFOCSetting.splice(vesselMachinery.id, 1)
        }
    }

    function handleSFOCEEDIXIChanges(e: any) {
        setEedixi(e.target.value);
        SFOCSetting.splice(index, 1)
        SFOCSetting.splice(index, 0, {
            id: vesselMachinery.id, eedi_eexi_technical_file: (e.target.value), nox_technical_file: nox, vessel_name: VesselID
        })
        updateSFOCRow();
    }

    function handleSFOCNOXChanges(e: any) {
        setNox(e.target.value);
        SFOCSetting.splice(index, 1)
        SFOCSetting.splice(index, 0, {
            id: vesselMachinery.id, eedi_eexi_technical_file: eedixi, nox_technical_file: (e.target.value), vessel_name: VesselID
        })
        updateSFOCRow();
    }
    return (

        <tr key={vesselMachinery.id}>
            <td>{index + 1}</td>
            <td>{vesselMachinery.vessel_machinery_name}</td>
            <td><input
                className="form-check-input"
                type="checkbox"
                name='sfoc'
                id={`formCheck-${vesselMachinery.id}`}
                value={(sfoc).toString()}
                onChange={handleSFOCCheckbox}
            /></td>
            <td>
                <div className="mb-3 input-group">
                    <Input
                        type="text"
                        name={`ee_txtbox${vesselMachinery.id}`}
                        className="form-control"
                        id={`${vesselMachinery.id}_ee`}
                        disabled={!sfoc}
                        onBlur={handleSFOCEEDIXIChanges}
                    />
                </div>
            </td>
            <td>
                <div className="mb-3 input-group">
                    <Input
                        type="text"
                        name={`nox_txtbox${vesselMachinery.id}`}
                        className="form-control"
                        id={`${vesselMachinery.id}_nox`}
                        disabled={!sfoc}
                        onBlur={handleSFOCNOXChanges}
                    />
                </div>
            </td>
        </tr>
    )
}
